import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  ProgressBar,
  ListGroup,
  Dropdown,
  Table,
  Alert,
} from "react-bootstrap";
import {
  FaChartBar,
  FaUsers,
  FaTicketAlt,
  FaGavel,
  FaUserPlus,
  FaFolderPlus,
  FaFileAlt,
  FaWarehouse,
  FaBriefcase,
  FaChevronRight,
  FaExclamationCircle,
  FaCheckCircle,
  FaClock,
  FaEye,
  FaEdit,
  FaTrash,
  FaArrowUp,
  FaArrowDown,
  FaFilter,
  FaSearch,
  FaBell,
  FaCog,
  FaCalendar,
  FaChartLine,
  FaDollarSign,
  FaBoxOpen,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { logout } from "../redux/authSlice/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../apiServices/EmpApiServices";
import { setEmpData } from "../redux/empSlice/empSlice";
import { useNavigate } from "react-router-dom";
import { fetchAcutionVehicles, fetchAuctionVehicles } from "../apiServices/AuctionApiServices";
import { setAuctionData } from "../redux/auctionSlice/auctionSlice";
import moment from "moment";
import { fetchTickets } from "../apiServices/SupportTicketApiServices";
import { setTicketData } from "../redux/supportTicketSlice/supportTicketSlice";
import { fetchYards } from "../apiServices/YardApiServices";
import { setYardData } from "../redux/yardSlice/yardSlice";
import { MdPermMedia } from "react-icons/md";
const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { empList } = useSelector((state) => state.emp);
  const { auctionList } = useSelector((state) => state.auction);
  const { yardList } = useSelector((state) => state.yard);
  const { ticketList, closedPercentage } = useSelector((state) => state.ticket);
  // Static data for the dashboard
  const [dashboardData] = useState({
    auction: {
      listLength: 24,
      activeAuctions: 8,
      upcomingAuctions: 5,
      completedAuctions: 11,
      totalBids: 1456,
      revenue: "$89,450",
      recentAuctions: [
        {
          id: 1,
          title: "Vintage Car Collection",
          status: "active",
          bids: 42,
          endDate: "2024-02-15",
        },
        {
          id: 2,
          title: "Art Gallery Pieces",
          status: "upcoming",
          bids: 0,
          startDate: "2024-02-20",
        },
        {
          id: 3,
          title: "Electronics Lot",
          status: "completed",
          bids: 156,
          revenue: "$12,800",
        },
      ],
    },
    supportTickets: {
      total: 18,
      open: 12,
      resolved: 6,
      urgent: 3,
      responseRate: "92%",
      recentTickets: [
        {
          id: 1,
          user: "John D.",
          issue: "Payment Problem",
          priority: "high",
          time: "2h ago",
        },
        {
          id: 2,
          user: "Sarah M.",
          issue: "Account Access",
          priority: "medium",
          time: "4h ago",
        },
        {
          id: 3,
          user: "Mike R.",
          issue: "Bidding Issue",
          priority: "low",
          time: "1d ago",
        },
      ],
    },
    employees: {
      total: 15,
      active: 14,
      onLeave: 1,
      departments: [
        { name: "Sales", count: 5, color: "primary" },
        { name: "Support", count: 4, color: "success" },
        { name: "Admin", count: 3, color: "info" },
        { name: "IT", count: 3, color: "warning" },
      ],
      recentHires: [
        {
          id: 1,
          name: "Alex Johnson",
          role: "Support Agent",
          date: "2024-01-15",
          avatarColor: "bg-primary",
        },
        {
          id: 2,
          name: "Maria Garcia",
          role: "Auction Manager",
          date: "2024-01-10",
          avatarColor: "bg-success",
        },
      ],
    },
    yards: {
      total: 8,
      active: 7,
      underMaintenance: 1,
      capacity: "85%",
      locations: [
        { name: "NYC", lots: 120, status: "active" },
        { name: "LA", lots: 85, status: "active" },
        { name: "Chicago", lots: 95, status: "maintenance" },
        { name: "Miami", lots: 65, status: "active" },
      ],
    },
    cases: {
      total: 32,
      open: 18,
      closed: 14,
      types: [
        { name: "Dispute", count: 12, color: "danger" },
        { name: "Refund", count: 8, color: "warning" },
        { name: "Account", count: 7, color: "info" },
        { name: "Technical", count: 5, color: "secondary" },
      ],
    },
  });

  useEffect(() => {
    loadData();
  }, []);
  const loadData = async () => {
    const getEmpData = await fetchEmployees();
    if (getEmpData.success) {
      dispatch(setEmpData(getEmpData.emp));
    }
    const getAuctionData = await fetchAuctionVehicles();
    if (getAuctionData.success) {
      dispatch(setAuctionData(getAuctionData.data));
    }
    const getSupportTicketData = await fetchTickets();
    if (getSupportTicketData.success) {
      dispatch(setTicketData(getSupportTicketData.data));
    }
    const getYardData = await fetchYards();
    if (getYardData.success) {
      dispatch(setYardData(getYardData.yards));
    }
  };
  console.log(ticketList, "ticketList");

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };

  const cardVariants = {
    hover: {
      y: -5,
      transition: {
        duration: 0.3,
      },
    },
  };
  const handleLogOut = async () => {
    await dispatch(logout());
  };

  const StatCard = ({ title, value, icon: Icon, color, change, children }) => (
    <motion.div
      variants={itemVariants}
      whileHover="hover"
      // variants={cardVariants}
    >
      <Card className="h-100 shadow-sm border-0">
        <Card.Body>
          <Row className="align-items-center">
            <Col xs={8}>
              <div className="d-flex align-items-center mb-2">
                <div
                  className={`p-2 rounded-circle me-3 bg-${color} bg-opacity-10`}
                >
                  <Icon className={`text-${color}`} size={24} />
                </div>
                {change && (
                  <Badge
                    bg={change > 0 ? "success" : "danger"}
                    className="ms-2"
                  >
                    {change > 0 ? <FaArrowUp /> : <FaArrowDown />}{" "}
                    {Math.abs(change)}%
                  </Badge>
                )}
              </div>
              <h3 className="fw-bold mb-1">{value}</h3>
              <p className="text-muted mb-0">{title}</p>
              {children && <div className="mt-3">{children}</div>}
            </Col>
            <Col xs={4} className="text-end">
              <div className="position-relative" style={{ height: "80px" }}>
                <div
                  className={`position-absolute w-100 h-100 rounded bg-${color} bg-opacity-10`}
                ></div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </motion.div>
  );

  const ActionButton = ({ text, icon: Icon, variant, onClick }) => (
    <motion.div whileTap={{ scale: 0.95 }}>
      <Button
        variant={variant}
        onClick={onClick}
        className="d-flex align-items-center justify-content-center w-100 py-3"
      >
        <Icon className="me-2" />
        <span>{text}</span>
      </Button>
    </motion.div>
  );

  const SectionHeader = ({ title, icon: Icon, count, onViewAll }) => (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div className="d-flex align-items-center">
        <div className="p-2 bg-primary bg-opacity-10 rounded-circle me-3">
          <Icon className="text-primary" />
        </div>
        <div>
          <h4 className="fw-bold mb-0">{title}</h4>
          {count && (
            <Badge bg="primary" className="ms-2">
              {count}
            </Badge>
          )}
        </div>
      </div>
      <Button
        variant="link"
        onClick={onViewAll}
        className="text-decoration-none"
      >
        View All <FaChevronRight className="ms-1" />
      </Button>
    </div>
  );

  return (
    <Container fluid className="py-4 bg-light min-vh-100">
      {/* Header */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="mb-4"
      >
        <Row className="align-items-center mb-4">
          <Col>
            <h1 className="fw-bold text-dark mb-1">
              Auction Management Dashboard
            </h1>
            <p className="text-muted mb-0">
              Welcome back! Here's what's happening today.
            </p>
          </Col>
          <Col xs="auto">
            <div
              className="user-info d-flex justify-content-center align-items-center bg-primary text-white"
              onClick={() => handleLogOut()}
            >
              <div className="text-center">
                <span>Log Out</span>
              </div>
            </div>
          </Col>
        </Row>
      </motion.div>

      {/* Stats Grid */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <Row className="g-3 mb-4">
          <Col md={3}>
            <StatCard
              title="Auction List"
              value={auctionList.length}
              icon={FaGavel}
              color="purple"
              // change={}
            >
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  <span className="text-success">●</span> Active:{" "}
                  {
                    auctionList.filter(
                      (indAuction) => indAuction?.auction?.status === "Live",
                    ).length
                  }
                </small>
                <small className="text-muted">
                  <span className="text-primary">●</span> Upcoming:{" "}
                  {
                    auctionList.filter(
                      (indAuction) =>
                        indAuction?.auction?.status === "Upcoming",
                    ).length
                  }
                </small>
              </div>
            </StatCard>
          </Col>

          <Col md={3}>
            <StatCard
              title="Support Tickets"
              value={ticketList?.length}
              icon={FaTicketAlt}
              color="warning"
              // change={-5}
            >
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  <FaExclamationCircle className="text-danger me-1" />
                  Open:{" "}
                  {
                    ticketList.filter((indTic) => indTic.status === "open")
                      .length
                  }
                </small>
                <small className="text-muted">
                  <FaCheckCircle className="text-success me-1" />
                  Resolved:{" "}
                  {
                    ticketList.filter((indTic) => indTic.status === "closed")
                      .length
                  }
                </small>
              </div>
            </StatCard>
          </Col>

          <Col md={3}>
            <StatCard
              title="Employee List"
              value={empList?.length}
              icon={FaUsers}
              color="success"
              // change={8}
            >
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  <FaCheckCircle className="text-success me-1" />
                  Active:{" "}
                  {empList.reduce(
                    (acc, emp) => acc + (emp.isActive ? 1 : 0),
                    0,
                  )}
                </small>
                <small className="text-muted">
                  <FaClock className="text-warning me-1" />
                  Not Active :{" "}
                  {empList.reduce(
                    (acc, emp) => acc + (!emp.isActive ? 1 : 0),
                    0,
                  )}
                </small>
              </div>
            </StatCard>
          </Col>

          <Col md={3}>
            <StatCard
              title="Yard Locations"
              value={yardList.length}
              icon={FaWarehouse}
              color="info"
              change={3}
            >
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  Active:{" "}
                  {yardList.filter((indYard) => indYard.isActive).length}
                </small>
                <small className="text-muted">
                  Verified:{" "}
                  {yardList.filter((indYard) => indYard.isVerified).length}
                </small>
              </div>
            </StatCard>
          </Col>
        </Row>
      </motion.div>

      {/* Action Buttons */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="mb-4"
      >
        <Card className="shadow-sm border-0">
          <Card.Body>
            <h5 className="fw-bold mb-3">Quick Actions</h5>
            <Row className="g-3">
              <Col md={2}>
                <ActionButton
                  text="Create Auction"
                  icon={FaGavel}
                  variant="secondary"
                  onClick={() => navigate('auctions/addAuction')}
                />
              </Col>
              <Col md={2}>
                <ActionButton
                  text="Add Employee"
                  icon={FaUserPlus}
                  variant="success"
                  onClick={() => navigate('employees/add')}
                />
              </Col>
              <Col md={2}>
                <ActionButton
                  text="Create Yard"
                  icon={FaWarehouse}
                  variant="info"
                  onClick={() => navigate('yards/addYard')}
                />
              </Col>
              <Col md={2}>
                <ActionButton
                  text="Create Case"
                  icon={FaBriefcase}
                  variant="primary"
                  onClick={() => navigate('cases/add')}
                />
              </Col>
              <Col md={2}>
                <ActionButton
                  text="Upload Image And Video"
                  icon={MdPermMedia}
                  variant="danger"
                  onClick={() => navigate('UploadMedia')}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </motion.div>

      {/* Main Content */}
      <Row className="g-4">
        {/* Left Column */}
        <Col lg={8}>
          {/* Auction Management */}
          <motion.div variants={itemVariants}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Body>
                <SectionHeader
                  title="Auction Management"
                  icon={FaGavel}
                  count={auctionList.length}
                  onViewAll={() => navigate("auctions/list")}
                />

                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Auction Title</th>
                      <th>Status</th>
                      <th>Bids</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {auctionList.slice(0, 4).map((indAuction) => (
                      <motion.tr
                        key={indAuction._id}
                        whileHover={{ backgroundColor: "rgba(0,0,0,0.02)" }}
                      >
                        <td>
                          <div className="d-flex align-items-center">
                            <FaBoxOpen className="text-primary me-2" />
                            <strong>{indAuction.title}</strong>
                          </div>
                        </td>
                        <td>
                          <Badge
                            bg={
                              indAuction?.auction?.status === "Live"
                                ? "success"
                                : indAuction?.auction?.status === "upcoming"
                                  ? "info"
                                  : "secondary"
                            }
                          >
                            {indAuction?.auction?.status}
                          </Badge>
                        </td>
                        <td>
                          <strong>{indAuction?.auction?.bids?.length}</strong>
                        </td>
                        <td>
                          <small className="text-muted">
                            {moment(indAuction?.auction?.startTime).format(
                              "DD MMM YYYY",
                            )}
                          </small>
                        </td>
                        <td>
                          <div className="d-flex gap-2">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() =>
                                navigate(`/auctions/get/${indAuction._id}`)
                              }
                            >
                              <FaEye />
                            </Button>
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() =>
                                navigate(
                                  `/auctions/editAuction/${indAuction._id}`,
                                )
                              }
                            >
                              <FaEdit />
                            </Button>
                          </div>
                        </td>
                      </motion.tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className="shadow-sm border-0 h-100 mt-2">
              <Card.Body>
                <SectionHeader
                  title="Yard Management"
                  icon={FaWarehouse}
                  count={yardList.length}
                  onViewAll={() => navigate("yards/list")}
                />

                <div className="mb-4">
                  <h6 className="fw-bold mb-3">Yard Locations</h6>
                  <ListGroup variant="flush">
                    {yardList.map((yard, index) => (
                      <ListGroup.Item
                        key={index}
                        className="d-flex justify-content-between align-items-center border-0 py-2"
                      >
                        <div className="d-flex align-items-center">
                          <FaWarehouse
                            className={`me-3 ${yard.yardStatus === "operational" ? "text-success" : "text-warning"}`}
                          />
                          <div>
                            <h6 className="fw-bold mb-0">{yard?.yardName}</h6>
                            <small className="text-muted">
                              {yard?.occupancy} lots available
                            </small>
                          </div>
                        </div>
                        <Badge
                          bg={
                            yard.yardStatus === "operational"
                              ? "success"
                              : "warning"
                          }
                        >
                          {yard.yardStatus}
                        </Badge>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>

                <Card className="bg-light border-0">
                  <Card.Body>
                    <Row>
                      <Col>
                        <div className="text-center">
                          <h4 className="fw-bold text-success">
                            {yardList.reduce(
                              (acc, yard) => acc + yard?.occupancy,
                              0,
                            )}
                          </h4>
                          <small className="text-muted">Total Capacity</small>
                        </div>
                      </Col>
                      <Col>
                        <div className="text-center">
                          <h4 className="fw-bold text-primary">
                            {yardList.reduce(
                              (acc, yard) => acc + yard?.parkedVehicles,
                              0,
                            )}
                          </h4>
                          <small className="text-muted">Parked Vehicle</small>
                        </div>
                      </Col>
                      {/* <Col>
                        <div className="text-center">
                          <h4 className="fw-bold text-warning">
                            {dashboardData.yards.underMaintenance}
                          </h4>
                          <small className="text-muted">
                            Under Maintenance
                          </small>
                        </div>
                      </Col> */}
                    </Row>
                  </Card.Body>
                </Card>
              </Card.Body>
            </Card>
          </motion.div>
        </Col>

        {/* Right Column */}
        <Col lg={4}>
          {/* Support Tickets */}
          <motion.div variants={itemVariants}>
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body>
                <SectionHeader
                  title="Support Tickets"
                  icon={FaTicketAlt}
                  count={ticketList.length}
                  onViewAll={() => navigate("tickets/list")}
                />

                <ListGroup variant="flush">
                  {ticketList.slice(0, 4).map((ticket) => (
                    <motion.div key={ticket.id} whileHover={{ x: 5 }}>
                      <ListGroup.Item className="border-0 py-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div>
                            <h6 className="fw-bold mb-1">{ticket?.name}</h6>
                            <p className="text-muted mb-0">{ticket?.subject}</p>
                          </div>
                          <Badge
                            bg={ticket.status === "open" ? "danger" : "success"}
                          >
                            {ticket.status}
                          </Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <small className="text-muted">
                            {moment(ticket?.createdAt).fromNow()}
                          </small>
                        </div>
                      </ListGroup.Item>
                    </motion.div>
                  ))}
                </ListGroup>

                <div className="mt-3">
                  <div className="d-flex justify-content-between mb-2">
                    <small>Response Rate</small>
                    <small className="fw-bold">{closedPercentage}%</small>
                  </div>
                  <ProgressBar
                    now={closedPercentage}
                    variant="success"
                    className="mb-3"
                  />
                </div>
              </Card.Body>
            </Card>
          </motion.div>

          {/* Employee Directory */}
          <motion.div variants={itemVariants}>
            <Card className="shadow-sm border-0">
              <Card.Body>
                <SectionHeader
                  title="Employee Directory"
                  icon={FaUsers}
                  count={empList.slice(0, 4).length}
                  onViewAll={() => navigate("employees/list")}
                />

                <div className="mb-4">
                  <h6 className="fw-bold mb-3">Emp List</h6>
                  {empList.slice(0, 4).map((employee, index) => (
                    <div
                      key={employee._id}
                      className="d-flex align-items-center mb-3"
                    >
                      <div
                        className={`text-white rounded-circle d-flex align-items-center justify-content-center me-3 ${
                          index % 2 === 0 ? "bg-primary" : "bg-success"
                        }`}
                        style={{ width: "40px", height: "40px" }}
                      >
                        {employee.name.charAt(0)}
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-bold mb-0">{employee.name}</h6>
                        <small className="text-muted">{employee.phoneNo}</small>
                      </div>
                      <div className="text-end">
                        <small className="fw-bold">{employee.role}</small>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </motion.div>
        </Col>
      </Row>

      {/* Bottom Row - Cases and Yards */}
      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="mt-4"
      >
        <Row className="g-4">
          <Col md={6}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Body>
                <SectionHeader
                  title="Case Management"
                  icon={FaBriefcase}
                  count={dashboardData.cases.total}
                  onViewAll={() => console.log("View all cases")}
                />

                <div className="mb-4">
                  <div className="d-flex gap-2 mb-3">
                    <Button
                      variant={
                        activeFilter === "all" ? "primary" : "outline-primary"
                      }
                      size="sm"
                      onClick={() => setActiveFilter("all")}
                    >
                      All
                    </Button>
                    <Button
                      variant={
                        activeFilter === "open" ? "success" : "outline-success"
                      }
                      size="sm"
                      onClick={() => setActiveFilter("open")}
                    >
                      Open
                    </Button>
                    <Button
                      variant={
                        activeFilter === "closed"
                          ? "secondary"
                          : "outline-secondary"
                      }
                      size="sm"
                      onClick={() => setActiveFilter("closed")}
                    >
                      Closed
                    </Button>
                  </div>

                  <Row>
                    {dashboardData.cases.types.map((type, index) => (
                      <Col key={index} xs={6} className="mb-3">
                        <Card
                          className={`border-${type.color} border-start border-4`}
                        >
                          <Card.Body>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6 className="fw-bold mb-0">{type.name}</h6>
                                <small className="text-muted">Cases</small>
                              </div>
                              <Badge bg={type.color} className="fs-6">
                                {type.count}
                              </Badge>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>

                <Alert variant="light" className="mb-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{dashboardData.cases.open}</strong> open cases
                      <div className="text-muted">
                        Out of {dashboardData.cases.total} total cases
                      </div>
                    </div>
                    <ProgressBar
                      now={
                        (dashboardData.cases.closed /
                          dashboardData.cases.total) *
                        100
                      }
                      style={{ width: "100px" }}
                    />
                  </div>
                </Alert>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Body>
                <SectionHeader
                  title="Yard Management"
                  icon={FaWarehouse}
                  count={dashboardData.yards.total}
                  onViewAll={() => console.log("View all yards")}
                />

                <div className="mb-4">
                  <h6 className="fw-bold mb-3">Yard Locations</h6>
                  <ListGroup variant="flush">
                    {dashboardData.yards.locations.map((yard, index) => (
                      <ListGroup.Item
                        key={index}
                        className="d-flex justify-content-between align-items-center border-0 py-2"
                      >
                        <div className="d-flex align-items-center">
                          <FaWarehouse
                            className={`me-3 ${yard.status === "active" ? "text-success" : "text-warning"}`}
                          />
                          <div>
                            <h6 className="fw-bold mb-0">{yard.name}</h6>
                            <small className="text-muted">
                              {yard.lots} lots available
                            </small>
                          </div>
                        </div>
                        <Badge
                          bg={yard.status === "active" ? "success" : "warning"}
                        >
                          {yard.status}
                        </Badge>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>

                <Card className="bg-light border-0">
                  <Card.Body>
                    <Row>
                      <Col>
                        <div className="text-center">
                          <h4 className="fw-bold text-success">
                            {dashboardData.yards.capacity}
                          </h4>
                          <small className="text-muted">Total Capacity</small>
                        </div>
                      </Col>
                      <Col>
                        <div className="text-center">
                          <h4 className="fw-bold text-primary">
                            {dashboardData.yards.active}
                          </h4>
                          <small className="text-muted">Active Yards</small>
                        </div>
                      </Col>
                      <Col>
                        <div className="text-center">
                          <h4 className="fw-bold text-warning">
                            {dashboardData.yards.underMaintenance}
                          </h4>
                          <small className="text-muted">
                            Under Maintenance
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </motion.div> */}

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="mt-4 pt-3 border-top"
      >
        <Row className="align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center me-4">
                <div className="w-3 h-3 bg-success rounded-circle me-2"></div>
                <small className="text-muted">All systems operational</small>
              </div>
              <small className="text-muted">
                <FaCalendar className="me-1" />
                Last updated: Today, 10:30 AM
              </small>
            </div>
          </Col>
          <Col xs="auto">
            <div className="d-flex gap-3">
              <small className="text-muted">
                Total Cases: {dashboardData.cases.total}
              </small>
              <small className="text-muted">
                Active Yards: {dashboardData.yards.active}
              </small>
              <small className="text-muted">
                Open Tickets: {dashboardData.supportTickets.open}
              </small>
            </div>
          </Col>
        </Row>
      </motion.div>
    </Container>
  );
};

export default Dashboard;
